import { computed as i, openBlock as p, createElementBlock as g, createElementVNode as l, normalizeStyle as u, createVNode as _ } from "vue";
import h from "../legend-group/legend-group.vue.js";
/* empty css               */
import b from "../../_virtual/_plugin-vue_export-helper.js";
const S = { class: "stats-bar" }, f = { class: "ds-margin-top-12 ds-md-margin-top-24" }, x = "DsStatsBar", y = /* @__PURE__ */ Object.assign({
  name: x
}, {
  __name: "stats-bar",
  props: {
    items: {
      type: Array,
      required: !0,
      validator: (t) => {
        const a = t.reduce((n, s) => n + s.percentage, 0);
        return t.length <= 6 && a === 100;
      }
    }
  },
  setup(t) {
    const r = [
      { name: "black", hex: "#00112c" },
      { name: "green", hex: "#0abf53" },
      { name: "yellow", hex: "#ffc200" },
      { name: "blue", hex: "#0070f5" },
      { name: "grey-500", hex: "#d1d5da" },
      { name: "grey-1900", hex: "#5c687c" }
    ], a = t, n = i(() => {
      let e = 0;
      return `linear-gradient(to right, ${a.items.map((c, m) => {
        const d = `${r[m].hex} ${e}% ${e + c.percentage}%`;
        return e += c.percentage, d;
      }).join(", ")})`;
    }), s = i(() => a.items.slice(0, r.length).map((e, o) => ({
      ...e,
      color: r[o].name
    })));
    return (e, o) => (p(), g("div", S, [
      l("div", {
        class: "stats-bar__bar",
        style: u({ background: n.value }),
        "aria-hidden": "true"
      }, null, 4),
      l("div", f, [
        _(h, { items: s.value }, null, 8, ["items"])
      ])
    ]));
  }
}), k = /* @__PURE__ */ b(y, [["__scopeId", "data-v-675346aa"]]);
export {
  k as default
};
